export default __webpack_public_path__ + "images/defaultAvatar.6008cd39311c2783907f4a2b3521cc2e.jpg";